namespace Areas.Employee.Accruals {
    "use strict";

    export function showAddAccrualDialog() {
        const params = {
            employeeId : $('#AccrualsGrid').dxDataGrid('instance').option('EmployeeId')
        };

        const dialog = new Areas.Dialogs.CreateEmployeeAccrual.CreateEmployeeAccrualDialog(closeDialog, params);
    }

    function closeDialog(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) {
            return;
        } 

        Areas.refreshGrid("AccrualsGrid");
    }
}